<div class="container">
  <gc-button
    [variant]="'plain'"
    [icon]="'ellipsisVertical'"
    [iconSize]="'medium'"
    (clicked)="openPopup()"
  />
  @if (showPopup) {
    <div
      class="options-popup"
      ipoClickOutside
      (clickOutside)="handleClickOutside()"
    >
      <gc-list>
        @for (button of buttonData; track $index) {
          @if (button.showButton) {
            <gc-list-item
              class="list-item"
              [label]="button.labelString | translate"
              [id]="button.labelString"
              [iconLeft]="button.iconName"
              (itemClicked)="
                button.labelString === 'reportInput.optionsButton.uploadImages'
                  ? imageUpload.click()
                  : itemClicked(button.clickedFn)
              "
            />
          }

          <input
            #imageUpload
            (change)="itemClicked(button.clickedFn, $event)"
            (cancel)="closePopup()"
            multiple="multiple"
            type="file"
            name="picture"
            [accept]="mimeType"
            class="file-upload-input"
            [style.display]="'none'"
          />
        }
      </gc-list>
    </div>
  }
  @if (showErrorPreventionModal()) {
    <app-error-prevention-modal
      (proceed)="errorPreventionProceed()"
      (cancel)="errorPreventionCancel()"
    />
  }
</div>
